import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.find";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { setSchoolSubjectSave } from '@data/setting';
import { gender } from "../../../../utils/enumeration";
export default {
  name: 'transfer-detail-dialog',
  props: {
    configObj: Object
  },
  data: function data() {
    return {
      configVo: this.configObj,
      operationName: '查看',
      sexList: gender(),
      form: {
        studentName: '',
        // 学生姓名
        studentSex: '',
        studentSid: '',
        destOrgName: '',
        destGradeName: '',
        destSchoolClassName: '',
        destSchoolTermName: '',
        destProvinceName: '',
        destCityName: '',
        destCountyName: '',
        destSchoolName: '',
        oriOrgName: '',
        oriSchoolTermName: '',
        oriGradeName: '',
        oriSchoolClassName: '',
        oriProvinceName: '',
        oriCityName: '',
        oriCountyName: '',
        oriSchoolName: ''
      }
    };
  },
  mounted: function mounted() {
    // console.log(this.sexList)
    this.detail();
  },
  methods: {
    // 性别映射
    sexFn: function sexFn(val) {
      var obj = this.sexList.find(function (ele) {
        return ele.code === val;
      }) || '';

      if (this.checkIsNull(obj)) {
        return '';
      }

      return obj.text;
    },
    // 获取数据
    detail: function detail() {
      var _this = this;

      Object.keys(this.form).forEach(function (item) {
        _this.form[item] = _this.configObj.row.studentTransferSchool[item] || '';
      }); // 转入学校信息

      this.form.studentSex = this.sexFn(this.form.studentSex);
      this.form.destProvinceName = this.configObj.row.destProvinceName || '';
      this.form.destCityName = this.configObj.row.destCityName || '';
      this.form.destCountyName = this.configObj.row.destCountyName || '';
      this.form.destSchoolName = this.configObj.row.destSchoolName || '';
      this.form.destGradeName = this.configObj.row.destGradeName || '';
      this.form.destSchoolClassName = this.configObj.row.destSchoolClassName || ''; // 转出学校信息

      this.form.oriProvinceName = this.configObj.row.oriProvinceName || '';
      this.form.oriCountyName = this.configObj.row.oriCountyName || '';
      this.form.oriCityName = this.configObj.row.oriCityName || '';
      this.form.oriSchoolName = this.configObj.row.oriSchoolName || '';
      this.form.oriGradeName = this.configObj.row.oriGradeName || '';
      this.form.oriSchoolClassName = this.configObj.row.oriSchoolClassName || '';
    },
    // 取消
    cancel: function cancel() {
      this.configVo.dialog = false;
    },
    // 判空方法
    checkIsNull: function checkIsNull(fieldVal) {
      return undefined === fieldVal || null === fieldVal || '' === fieldVal;
    }
  }
};